export const LogoRegular: {
  name: 'logo_regular-5d0d7e20382c'
} = {
  name: 'logo_regular-5d0d7e20382c'
}
